import { Controller } from "@hotwired/stimulus"

// 一覧の一括操作で使う選択制御。行チェックボックスの全選択/全解除トグル、
// 選択件数の表示、選択が 0 件のときの submit ボタン無効化を担う。
export default class extends Controller {
  static targets = ["checkbox", "all", "submit", "count"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.allTarget.checked })
    this.refresh()
  }

  refresh() {
    const total = this.checkboxTargets.length
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasAllTarget) {
      this.allTarget.checked = total > 0 && selected === total
      this.allTarget.indeterminate = selected > 0 && selected < total
    }

    this.submitTargets.forEach((button) => { button.disabled = selected === 0 })

    if (this.hasCountTarget) this.countTarget.textContent = selected
  }
}
